import React, { ReactElement, useContext } from 'react'
import styled from 'styled-components';
import { TabsContext } from './Tabs';

interface IProps {
    children: ReactElement,
    step: number
}

interface TabHeaderContainerProps {
    isCurrent: boolean,
    step: number,
    isLast: boolean
}

const TabHeaderContainer = styled.div<TabHeaderContainerProps>`
    cursor: pointer;
    font-size: ${props => props.isCurrent ? "120%" : "100%"};
    padding: 5px;
    /* ${props => props.isCurrent && props.step === 0 && `
        
    `} */
    /* ${props => !props.isCurrent && props.step === 0 && `
        border-top: 2px dashed green;
    `}
    ${props => props.isCurrent && props.isLast && `
        
    `}
    ${props => !props.isCurrent && props.isLast && `
        border-bottom: 2px dashed green;
    `} */
    ${props => props.isCurrent && `
        border-left: 2px solid green;
        border-bottom: 2px solid green;      
        border-top: 2px solid green;
    `}
    ${props => !props.isCurrent && `
        border-left: 2px dashed green;
        border-top: 2px dashed green;
        border-bottom: 2px dashed green;
        border-right: 2px solid green;
    `}
`;

export default function TabHeader(props: IProps) {
    const tabsContext = useContext(TabsContext);

    return (
        <TabHeaderContainer step={props.step} isLast={props.step === tabsContext.totalNumberOfSteps - 1} isCurrent={tabsContext.step === props.step} onClick={() => tabsContext.activateStep(props.step)}>
            {props.children}
        </TabHeaderContainer>
    )
}